// JS file for Archive
$(() => {

$('.archive-open-more').on('click', () => {
  $('.archive-open-more-item').hide();
  $('.archive-item').show();
})

});
